import { render, staticRenderFns } from "./input_form.vue?vue&type=template&id=0a648b62&scoped=true"
import script from "./input_form.vue?vue&type=script&lang=js"
export * from "./input_form.vue?vue&type=script&lang=js"
import style0 from "./input_form.vue?vue&type=style&index=0&id=0a648b62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a648b62",
  null
  
)

export default component.exports